// Renders the cart drawer (template-parts/quick-cart.php) and the header badge from the server cart (cart.js).
import { subscribe, loadCart, getCart, removeItem, applyCoupon, removeCoupon, totals, initialCount, holdCountdown, holdSecondsLeft } from './cart.js';
import { qs, qsa, tpl, on, t } from './dom.js';
import { track, lineItem } from './track.js';

function renderBadges(count) {
  qsa('[data-cart-count]').forEach((b) => {
    b.textContent = String(count);
    b.classList.toggle('scale-0', count === 0);
    b.classList.toggle('scale-100', count > 0);
  });
}

export function initCartDrawer() {
  renderBadges(initialCount());
  const drawer = qs('#cart-drawer');
  if (!drawer) return;
  const list = qs('[data-cart-list]', drawer);
  const empty = qs('[data-cart-empty]', drawer);
  const footer = qs('[data-cart-footer]', drawer);
  const timer = qs('[data-cart-timer]', drawer);
  const timerText = qs('[data-cart-timer-text]', drawer);
  let tick = null;

  function renderTimer(state) {
    if (!timer) return;
    const txt = holdCountdown(state);
    timer.hidden = !txt;
    if (txt && timerText) timerText.textContent = t('woo.reserved_for', { time: txt });
    if (txt && holdSecondsLeft(state) === 0) { loadCart(true); }
  }

  subscribe((state) => {
    const tot = totals(state);
    renderBadges(tot.count);
    list.innerHTML = '';
    (state.items || []).forEach((item) => {
      const details = [item.name, item.seat].filter(Boolean).join(' · ') + (item.qty > 1 ? ` · ${item.qty} × ${item.fmt_unit}` : '');
      const date = item.type === 'product' ? [t('shop.breadcrumb_shop'), item.location].filter(Boolean).join(' · ') : [item.date_display, item.location].filter(Boolean).join(' · ');
      const node = tpl('tpl-cart-item', { image: item.image, title: item.title, date, details, price: item.fmt_line });
      qs('[data-remove]', node).addEventListener('click', (e) => { e.currentTarget.disabled = true; removeItem(item.key); });
      list.appendChild(node);
    });
    empty.hidden = tot.count > 0;
    footer.hidden = tot.count === 0;
    qs('[data-cart-subtotal]', drawer).textContent = tot.fmt.subtotal;
    qs('[data-cart-fee]', drawer).textContent = tot.fmt.fee;
    qs('[data-cart-total]', drawer).textContent = tot.fmt.total;
    const coupon = tot.coupons[0] || null;
    qs('[data-cart-discount-row]', drawer).hidden = !coupon;
    qs('[data-cart-discount]', drawer).textContent = tot.fmt.discount;
    qs('[data-coupon-form]', drawer).hidden = !!coupon;
    qs('[data-coupon-applied]', drawer).hidden = !coupon;
    qs('[data-coupon-code]', drawer).textContent = coupon ? coupon.code : '';
    const checkout = qs('[data-cart-checkout]', drawer);
    if (checkout && state.checkout_url) checkout.href = state.checkout_url;
    // Phase 9: branded shop attribution badge + shipping row.
    const badge = qs('[data-cart-shop]', drawer);
    if (badge) {
      badge.hidden = !state.shop;
      if (state.shop) { qs('[data-cart-shop-name]', badge).textContent = t('branded.shop_badge', { name: state.shop.name }); badge.href = state.shop.url || '#'; }
    }
    const shipRow = qs('[data-cart-shipping-row]', drawer);
    if (shipRow) { shipRow.hidden = !state.needs_shipping; qs('[data-cart-shipping]', drawer).textContent = (state.fmt && state.fmt.shipping) || ''; }
    const feeRow = qs('[data-cart-fee-row]', drawer);
    if (feeRow) feeRow.hidden = !(state.fee > 0);
    renderTimer(state);
    clearInterval(tick);
    if (tot.count > 0) tick = setInterval(() => renderTimer(state), 1000);
  });

  on(drawer, 'submit', '[data-coupon-form]', async (e, form) => {
    e.preventDefault();
    const btn = qs('button', form);
    if (btn) btn.disabled = true;
    const ok = await applyCoupon(form.code.value);
    if (btn) btn.disabled = false;
    if (ok) form.reset();
  });
  on(drawer, 'click', '[data-coupon-remove]', (e) => {
    e.preventDefault();
    const code = qs('[data-coupon-code]', drawer).textContent;
    removeCoupon(code);
  });

  // 1.9.8 tracking: view_cart when the visitor opens the drawer himself (header button – not the auto-open after an add)
  on(document, 'click', '[data-open="cart"]', () => {
    loadCart().then((s) => {
      if (s && s.items && s.items.length) track('view_cart', { currency: s.currency || 'EUR', value: s.total, items: s.items.map((l) => lineItem(l, l.qty)) });
    }).catch(() => {});
  });

  // Load the cart once per page (cheap GET); refresh when the drawer opens after a while.
  loadCart();
  document.addEventListener('kt:overlay:open', (e) => {
    if (!e.detail || e.detail.name !== 'cart') return;
    const s = getCart();
    if (!s || Date.now() - s.receivedAt > 10000) loadCart(true);
  });
}
